import * as React from 'react';

import { DataRequestActionTypes } from '../../constants/actionTypes';
import { FormId } from '../../constants/formId';
import FormModal from '../modal/formModal';

import BaseClientForm from './baseClientForm';

// eslint-disable-next-line react/prefer-stateless-function
export class EditClientForm extends React.Component<{}, { isDst: boolean }> {
  constructor(props: any) {
    super(props);

    this.state = {
      isDst: true,
    };
  }

  handleTimezoneChange = (isDst: boolean) => {
    this.setState({ isDst });
  };

  public render() {
    const { isDst } = this.state;

    return (
      <>
        <FormModal
          formId={FormId.EditClientForm}
          formTitle="Edit Client"
          submitActionType={DataRequestActionTypes.EditClientRequested}
          smallButton
          partialSubmit
          hideButton
          initialValues={{
            dst: isDst,
          }}
        >
          <BaseClientForm formId={FormId.EditClientForm} onTimezoneChange={this.handleTimezoneChange} />
        </FormModal>
      </>
    );
  }
}
